import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, CloseButton, Container, Form, InputGroup } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { serLogin } from '../../axios';
import { useDispatch, useSelector } from 'react-redux';
import { setUserinfo } from '../../store/modules/logininfo';
import langList from '../../utils/languagelist.json'

// 当前时间+时间限制=过期时间
function expirationTime(t) {
  const timeUnit = t.slice(-1);
  const timeValue = parseInt(t.slice(0, -1));
  let expirationTimestamp = Date.now();
  if (timeUnit === 's') {
    expirationTimestamp += timeValue * 1000;
  } else if (timeUnit === 'm') {
    expirationTimestamp += timeValue * 60 * 1000;
  } else if (timeUnit === 'h') {
    expirationTimestamp += timeValue * 60 * 60 * 1000;
  }
  return expirationTimestamp;
}

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState('password');
  const [msgError, setMsgError] = useState('');
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const {lg}=useSelector((state)=>state.language);

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    const storedRememberMe = localStorage.getItem('rememberMe');
    if (storedRememberMe && storedUsername) {
      setUsername(storedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleRememberMeChange = (event) => {
    setRememberMe(event.target.checked);
  };

  const handleSubmit = () => {
    // 验证用户名是否为有效的邮箱地址
    if (username.trim()==='') {
      setMsgError(langList.public1[lg]);
      return;
    };
    if (password.trim()==='') {
      setMsgError(langList.public2[lg]);
      return;
    };
    const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
    if (!emailRegex.test(username)) {
      setMsgError(langList.public3[lg]);
      return;
    };
    // 登录
    serLogin({name:username,pwd:password})
    .then(res =>{
      const code=res.code;
      if(code===2){
        setMsgError(langList.login1[lg]);
        return;
      };
      if(code===34){
        setMsgError(langList.login2[lg]);
        return;
      };
      //记住账号
      if (rememberMe) {
        localStorage.setItem('username', username);
        localStorage.setItem('rememberMe', true);
      } else {
        localStorage.removeItem('username');
        localStorage.removeItem('rememberMe');
      };
      // 把信息保存在redux中
      dispatch(setUserinfo({usern:res.usern,expires:expirationTime(res.timein),role:res.role,menu:true}))
      //回到主页面
      navigate('/',{replace:true});
    })
    .catch(err =>{
      setMsgError(err.message);
    });
  };

  
  const closeBtnClick = () => {
    navigate('/',{replace:true});
  };

  const passwordClick=()=>{
    if(showPassword==='password'){
      setShowPassword('text');
    }else{
      setShowPassword('password');
    }
  };

  const registerClick = ()=>{
    navigate('/register',{replace:true});
  }

  const getpwdClick = ()=>{
    navigate('/getpassword',{replace:true});
  }

  if(msgError){
    setTimeout(() => {
      setMsgError('');
    }, 5000);
  }

  return (
    <div>
      <Container className='d-flex justify-content-center align-items-center' style={{height:'90vh'}}>
        <Card className='shadow' style={{maxWidth:'25rem',width:'100%'}}>
          <Card.Header className='d-flex justify-content-between align-items-center py-3'>
            <span>{langList.login3[lg]}</span>
            <CloseButton onClick={closeBtnClick}/>
          </Card.Header>
          <Card.Body>
            <div className='py-4'></div>
            <InputGroup size="lg" className="mb-4">
              <InputGroup.Text>
                <img src='./pic/person.svg' alt=''/>
              </InputGroup.Text>
              <Form.Control
                id='login1'
                type="text"
                placeholder={langList.public4[lg]}
                value={username}
                onChange={handleUsernameChange}
              />
            </InputGroup>
            <InputGroup size="lg" className="mb-1">
              <InputGroup.Text>
                <img src='./pic/lock.svg' alt=''/>
              </InputGroup.Text>
              <Form.Control
                id='login2'
                type={showPassword}
                placeholder={langList.public5[lg]}
                value={password}
                onChange={handlePasswordChange}
              />
              <InputGroup.Text style={{cursor: 'pointer'}} onClick={passwordClick}>
                <img src={showPassword==='password'?'./pic/eye.svg':'./pic/eye-slash.svg'} alt=''/>
              </InputGroup.Text>
            </InputGroup>
            <div className='pb-5 position-relative'>
              <Alert 
                show={msgError===''?false:true} 
                variant={'danger'} 
                className='py-1 text-center text-danger position-absolute w-100'
              >
                {msgError}
              </Alert>
            </div>
            <div className='d-flex justify-content-between align-items-center my-4'>
              <Form.Check
                id='login3'
                type='checkbox'
                label={langList.login4[lg]}
                checked={rememberMe}
                onChange={handleRememberMeChange}
              />
              <Button
                variant="primary"
                className='w-50'
                size="lg"
                onClick={handleSubmit}
              >{langList.login3[lg]}</Button>
            </div>
          </Card.Body>
          <Card.Footer className='d-flex justify-content-between align-items-center py-3'>
            <Button
              variant="link"
              style={{textDecoration: 'none',color: 'black'}}
              onClick={getpwdClick}
            >{langList.login5[lg]}</Button>
            <Button
              variant="outline-success"
              className='w-25'
              onClick={registerClick}
            >{langList.login6[lg]}</Button>
          </Card.Footer>
        </Card>
      </Container>
    </div>
  )
}
